import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type StudentImportService from 'teacher-ui-client/services/student-import'
import type SessionService from 'teacher-ui-client/services/session'
import type RouterService from '@ember/routing/router-service'

export default class ConfirmRoute extends Route {
  @service studentImport!: StudentImportService

  @service session!: SessionService

  @service router!: RouterService

  beforeModel() {
    // Ensure this route is not entered with an invalid or already imported file
    if (!this.studentImport.importJob.valid || this.studentImport.importJob.imported) {
      void this.router.replaceWith('manage.students')
    }
  }

  /**
   * Extract the student-candidate pojo models from the csv validate response.
   */
  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const isSubco = this.session.currentTeacher.subcoFor(subscriptionType)

    return { isSubco, subscriptionType }
  }
}
